<template>
  <div>
    <div
      v-if="hasImage"
      class="highlight-image"
    >
      <AImage
        :img="getImage"
        :preset="getPreset"
        :ratio="getRatio"
        responsive
        contain
      />
    </div>
    <div class="highlight-content">
      <div
        v-if="getHighlightLeadline"
        class="highlight-leadline"
      >
        <h4>{{ getHighlightLeadline }}</h4>
      </div>
      <div
        v-if="getHighlightDescription"
        class="highlight-description"
        v-html="getHighlightDescription"
      />
      <div
        v-if="getHighlightTitle"
        class="highlight-name"
      >
        {{ getHighlightTitle }}
      </div>
    </div>
  </div>
</template>

<script>

import layoutMixin from './layouts-mixin'

export default {
  name: 'sp-feature-highlight-quote',
  mixins: [layoutMixin]
}
</script>

<style lang="scss" scoped>
  @import '~@scss/custom.scss';

  ::v-deep .highlight-image {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin-bottom: 2em;
    @include media-breakpoint-up(sm) {
      margin-bottom: 0;
      width: auto;
      max-width: 35%;
    }
    .a-image.responsive.contain img {
      position: relative;
    }
  }

 .highlight-content {
    flex-direction: column;
    display: flex;
    justify-content: center;
    width: 100%;
  }

  .highlight-title {
    margin: .75em 0em;
    color: var(--main-text-heading-color);
    font-weight: bold;
  }
  .highlight-description{
    margin-bottom:1rem;
    font-style: italic;
  }
  .highlight-description {
    color: var(--main-text-color);
  }
</style>
